exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.archive[data-v-34515670] {\n\ttext-indent: 3ch;\n\tpadding: 5px 10px;\n\tfont-size: 16px;\n}\n", ""]);

// exports
